import type { PredefinedCheckup } from '../types';

// ============================================================================
// STANDARD-VORSORGEPLAN (Einlingsschwangerschaft ohne Risiko)
// Nach Mutterschaftsrichtlinien: ca. alle 4 Wochen, ab SSW 32 alle 2 Wochen
// ============================================================================
export const PREDEFINED_CHECKUPS_STANDARD: PredefinedCheckup[] = [
  {
    ssw_week: 9,
    title: 'Erste Vorsorgeuntersuchung',
    description: 'Feststellung der Schwangerschaft, Blutuntersuchungen, Urintest',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 10,
    title: '1. Ultraschall (9.-12. SSW)',
    description: 'Ersttrimester-Screening, Nackenfaltenmessung möglich',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 12,
    title: 'Vorsorgeuntersuchung',
    description: 'Routineuntersuchung, Gewicht, Blutdruck, Urin',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 16,
    title: 'Vorsorgeuntersuchung',
    description: 'Routineuntersuchung, Herztonkontrolle',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 20,
    title: '2. Ultraschall (19.-22. SSW)',
    description: 'Organscreening, Größenmessung des Babys',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 24,
    title: 'Vorsorgeuntersuchung',
    description: 'Routineuntersuchung, ggf. Zuckerbelastungstest',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 26,
    title: 'Glukosetoleranztest',
    description: 'Oraler Glukosetoleranztest (oGTT) zur Schwangerschaftsdiabetes-Vorsorge',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 28,
    title: 'Vorsorgeuntersuchung',
    description: 'Routineuntersuchung, Anti-D-Prophylaxe bei Rhesus-negativ',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 30,
    title: '3. Ultraschall (29.-32. SSW)',
    description: 'Wachstumskontrolle, Lage des Babys, Fruchtwassermenge',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 32,
    title: 'Vorsorgeuntersuchung',
    description: 'Zweiwöchentliche Kontrollen beginnen, CTG möglich',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 34,
    title: 'Vorsorgeuntersuchung',
    description: 'Routineuntersuchung, Kindslage prüfen',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 36,
    title: 'Vorsorgeuntersuchung',
    description: 'B-Streptokokken-Abstrich, Geburtsplanung besprechen',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 37,
    title: 'Klinik-Anmeldung',
    description: 'Anmeldung im Krankenhaus/Geburtshaus',
    appointment_type: 'personal',
  },
  {
    ssw_week: 38,
    title: 'Vorsorgeuntersuchung',
    description: 'Wöchentliche Kontrollen mit CTG',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 39,
    title: 'Vorsorgeuntersuchung',
    description: 'CTG, Kontrolle der Geburtsvorbereitung',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 40,
    title: 'Errechneter Geburtstermin',
    description: 'Bei Terminüberschreitung: engmaschige Kontrollen',
    appointment_type: 'checkup',
  },
];

// ============================================================================
// RISIKO-VORSORGEPLAN (Risikoschwangerschaft: Alter ≥35, Vorerkrankungen etc.)
// Häufigere Kontrollen: alle 2 Wochen ab SSW 20, zusätzliche Ultraschalls
// ============================================================================
export const PREDEFINED_CHECKUPS_HIGH_RISK: PredefinedCheckup[] = [
  {
    ssw_week: 8,
    title: 'Erste Vorsorgeuntersuchung',
    description: 'Feststellung der Schwangerschaft, ausführliche Anamnese, Blutuntersuchungen',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 10,
    title: '1. Ultraschall (9.-12. SSW)',
    description: 'Ersttrimester-Screening, Nackenfaltenmessung empfohlen',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 12,
    title: 'Vorsorgeuntersuchung',
    description: 'Routineuntersuchung, Besprechung der Risikofaktoren',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 14,
    title: 'Vorsorgeuntersuchung',
    description: 'Kontrolle, ggf. weitere pränatale Diagnostik besprechen',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 16,
    title: 'Kontroll-Ultraschall',
    description: 'Zusätzlicher Ultraschall zur Wachstumskontrolle',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 18,
    title: 'Vorsorgeuntersuchung',
    description: 'Routineuntersuchung, Herztonkontrolle',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 20,
    title: '2. Ultraschall (Feindiagnostik)',
    description: 'Detailliertes Organscreening, Doppler-Untersuchung empfohlen',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 22,
    title: 'Vorsorgeuntersuchung',
    description: 'Zweiwöchentliche Kontrollen beginnen',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 24,
    title: 'Kontroll-Ultraschall',
    description: 'Wachstumskontrolle, Fruchtwassermenge, Zervixlänge',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 26,
    title: 'Glukosetoleranztest',
    description: 'Oraler Glukosetoleranztest (oGTT) zur Schwangerschaftsdiabetes-Vorsorge',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 28,
    title: 'Vorsorgeuntersuchung + Ultraschall',
    description: 'Wachstumskontrolle, Anti-D-Prophylaxe bei Rhesus-negativ, Doppler',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 30,
    title: '3. Ultraschall + CTG',
    description: 'Wachstumskontrolle, Lage des Babys, erstes CTG',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 32,
    title: 'Vorsorgeuntersuchung + CTG',
    description: 'Engmaschige Kontrollen mit CTG',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 33,
    title: 'Kontroll-Ultraschall',
    description: 'Wachstumskontrolle, Doppler-Sonographie',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 34,
    title: 'Vorsorgeuntersuchung + CTG',
    description: 'Routineuntersuchung, Kindslage prüfen',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 35,
    title: 'Klinik-Anmeldung',
    description: 'Frühere Anmeldung im Krankenhaus, Geburtsplanung besprechen',
    appointment_type: 'personal',
  },
  {
    ssw_week: 36,
    title: 'Vorsorgeuntersuchung + Ultraschall',
    description: 'B-Streptokokken-Abstrich, Wachstums- und Lagekontrolle',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 37,
    title: 'Vorsorgeuntersuchung + CTG',
    description: 'Wöchentliche Kontrollen mit CTG beginnen',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 38,
    title: 'Vorsorgeuntersuchung + CTG',
    description: 'CTG, ggf. Ultraschall',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 39,
    title: 'Vorsorgeuntersuchung + CTG',
    description: 'CTG, Besprechung Geburtseinleitung',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 40,
    title: 'Errechneter Geburtstermin',
    description: 'CTG, bei Risiko-SS ggf. frühere Einleitung besprechen',
    appointment_type: 'checkup',
  },
];

// ============================================================================
// MEHRLINGE-VORSORGEPLAN (Zwillinge, Drillinge etc.)
// Sehr engmaschige Kontrollen, häufige Ultraschalls zur Wachstumskontrolle
// Frühere Entbindungsplanung (Zwillinge oft SSW 37-38, Drillinge SSW 34-35)
// ============================================================================
export const PREDEFINED_CHECKUPS_MULTIPLES: PredefinedCheckup[] = [
  {
    ssw_week: 8,
    title: 'Erste Vorsorgeuntersuchung',
    description: 'Feststellung der Mehrlingsschwangerschaft, Chorionizität bestimmen',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 10,
    title: '1. Ultraschall (Mehrlinge)',
    description: 'Chorionizität/Amnionizität bestätigen, Nackenfaltenmessung bei beiden',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 12,
    title: 'Kontroll-Ultraschall',
    description: 'Wachstumskontrolle beider Babys, Ersttrimester-Screening',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 14,
    title: 'Vorsorgeuntersuchung',
    description: 'Routineuntersuchung, Überweisung an Perinatalzentrum empfohlen',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 16,
    title: 'Ultraschall Wachstumskontrolle',
    description: 'Wachstumsdiskordanz ausschließen, Fruchtwassermenge',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 18,
    title: 'Vorsorgeuntersuchung',
    description: 'Routineuntersuchung, Zervixlänge kontrollieren',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 20,
    title: 'Feindiagnostik (beide Babys)',
    description: 'Detailliertes Organscreening beider Babys, Doppler',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 22,
    title: 'Vorsorgeuntersuchung + Zervixkontrolle',
    description: 'Zervixlänge, Wachstumskontrolle',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 24,
    title: 'Ultraschall Wachstumskontrolle',
    description: 'Wachstum beider Babys vergleichen, Fruchtwassermenge',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 26,
    title: 'Glukosetoleranztest + Vorsorge',
    description: 'oGTT, Zervixkontrolle, ab jetzt zweiwöchentlich',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 28,
    title: 'Ultraschall + CTG',
    description: 'Wachstumskontrolle, erstes CTG, Lungenreifeinduktion besprechen',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 30,
    title: 'Vorsorgeuntersuchung + CTG',
    description: 'CTG für beide Babys, Anti-D-Prophylaxe bei Rhesus-negativ',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 31,
    title: 'Ultraschall Wachstumskontrolle',
    description: 'Wachstum, Doppler, Fruchtwassermenge',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 32,
    title: 'Vorsorgeuntersuchung + CTG',
    description: 'Engmaschige Kontrollen, B-Streptokokken-Abstrich',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 33,
    title: 'Klinik-Anmeldung (Perinatalzentrum)',
    description: 'Anmeldung am Perinatalzentrum, Geburtsplanung besprechen',
    appointment_type: 'personal',
  },
  {
    ssw_week: 34,
    title: 'Ultraschall + CTG',
    description: 'Wachstumskontrolle, Lage beider Babys, Entbindungsmodus besprechen',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 35,
    title: 'Vorsorgeuntersuchung + CTG',
    description: 'Wöchentliche Kontrollen, Geburtsbereitschaft prüfen',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 36,
    title: 'Ultraschall + CTG',
    description: 'Finale Wachstumskontrolle, Entbindungstermin festlegen',
    appointment_type: 'ultrasound',
  },
  {
    ssw_week: 37,
    title: 'Vorsorgeuntersuchung + CTG',
    description: 'Bei Zwillingen: Geplante Entbindung SSW 37-38 üblich',
    appointment_type: 'checkup',
  },
  {
    ssw_week: 38,
    title: 'Geplanter Entbindungstermin (Zwillinge)',
    description: 'Zwillinge werden meist nicht über SSW 38 hinaus getragen',
    appointment_type: 'checkup',
  },
];

// ============================================================================
// BACKWARD COMPATIBILITY - Legacy export
// ============================================================================
export const PREDEFINED_CHECKUPS = PREDEFINED_CHECKUPS_STANDARD;

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================

/**
 * Wählt den passenden Vorsorgeplan basierend auf Schwangerschaftstyp
 */
export function getPredefinedCheckups(
  isHighRisk: boolean,
  childCount: number
): PredefinedCheckup[] {
  // Mehrlinge haben höchste Priorität (auch wenn kein Risiko markiert)
  if (childCount > 1) {
    return PREDEFINED_CHECKUPS_MULTIPLES;
  }
  // Risikoschwangerschaft
  if (isHighRisk) {
    return PREDEFINED_CHECKUPS_HIGH_RISK;
  }
  // Normale Einlingsschwangerschaft
  return PREDEFINED_CHECKUPS_STANDARD;
}

/**
 * Gibt den Namen des Vorsorgeplan-Typs zurück
 */
export function getCheckupPlanType(
  isHighRisk: boolean,
  childCount: number
): { type: 'standard' | 'high_risk' | 'multiples'; label: string; description: string } {
  if (childCount > 1) {
    const label = childCount === 2 ? 'Zwillinge' : childCount === 3 ? 'Drillinge' : `${childCount} Mehrlinge`;
    return {
      type: 'multiples',
      label: `Mehrlingsvorsorge (${label})`,
      description: 'Engmaschige Kontrollen mit häufigen Ultraschalls zur Wachstumsüberwachung',
    };
  }
  if (isHighRisk) {
    return {
      type: 'high_risk',
      label: 'Risikoschwangerschaft',
      description: 'Häufigere Kontrollen ab SSW 20 mit zusätzlichen Ultraschalls und CTG',
    };
  }
  return {
    type: 'standard',
    label: 'Standard-Vorsorge',
    description: 'Reguläre Vorsorgeuntersuchungen nach Mutterschaftsrichtlinien',
  };
}

/**
 * Berechnet das Datum für eine SSW basierend auf dem ET
 * ET ist SSW 40+0, also berechnen wir rückwärts
 */
export function calculateDateForSSW(
  dueDate: Date,
  targetSSW: number
): Date {
  const weeksFromET = 40 - targetSSW;
  const result = new Date(dueDate);
  result.setDate(result.getDate() - weeksFromET * 7);
  return result;
}
